export default "https://yastatic.net/s3/frontend/vconf-frontend/_/attendees.f51fa6e3.svg";